<script lang="tsx">
  import { defineComponent, PropType } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Badge from '@xhs/yam-beer/cmp/common/Badge/Badge.vue'
  import { BeerStyleObj } from '../../../core'
  import {
    TabItemModifier,
    DefaultRenderParams,
    TabHeaderItem,
    RenderLabelType,
  } from './TabD'

  function DefaultRender(props: DefaultRenderParams): JSX.Element | string | undefined | number {
    const {
      item,
    } = props
    if (item?.slots?.tab) {
      return item.slots.tab()
    }
    if (props.renderLabel) {
      return props.renderLabel(item)
    }
    if (item?.count) {
      return (
        <Badge
          hidden={!item.count}
          content={item.count}
          bs={{ 'cmp.tab': 'badge' }}
          class="badge">
          {item.label}
        </Badge>
      )
    }
    return item.label
  }

  export default defineComponent({
    name: 'TabItem',
    props: {
      /**
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * primary | success | danger | warning | secondary
       * @type {primary|success|danger|warning|secondary}
       * @see style
       */
      modifier: {
        type: String as PropType<TabItemModifier>,
        default: 'primary',
      },
      /**
       * 渲染的条目对象
       */
      item: {
        type: Object as PropType<TabHeaderItem>,
        required: true,
      },
      /**
       * 标签的大小和空间
       * @type {s|m|l}
       */
      size: {
        type: String,
        default: 'm',
      },
      renderLabel: {
        type: Function as PropType<RenderLabelType>,
      },
      active: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { attrs }) {
      return () => (
        <NewBsBox
          bs={{
            'cmp.tab': 'item',
            'cmp.tab.sized': true,
            ...props.bs,
          }}
          context={props}
          {...attrs}
          data-active={props.active || undefined}
          data-disable={props.disabled || undefined}
          class="tab-item">
          {DefaultRender(props)}
        </NewBsBox>
    )
    },
  })
</script>
